<script setup lang="ts">
import { HeadingFieldsFragment } from '~/api/graphql/generated'

export type HeadingData = string | HeadingFieldsFragment | undefined

export type HeadingType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

type Heading = {
  text: string
  is: HeadingType
  isVisible: boolean
  look?: HeadingType
}

const props = defineProps<{
  data?: HeadingData
  is?: HeadingType
  isVisible?: boolean
  look?: HeadingType
}>()

const defaults = {
  text: '',
  is: 'h2',
  isVisible: true,
  look: undefined,
}

const text = computed(() => {
  if (typeof props.data === 'string') return props.data
  if (props.data?.fieldHeadingTitle?.value) return props.data.fieldHeadingTitle.value
  return defaults.text
})
const is = computed(() => {
  if (typeof props.data === 'string') return props.is || defaults.is
  if (props.data?.fieldHeadingType) return props.data.fieldHeadingType
  return props.is || defaults.is
})
const look = computed(() => props.look || defaults.look)
const isVisible = computed(() => {
  if (typeof props.data === 'string') return props.isVisible || defaults.isVisible
  return props.isVisible || props.data?.fieldVisible || defaults.isVisible
})
</script>

<template>
  <component :is="is" :class="['heading', look, { 'sr-only': !isVisible }]">
    <slot>{{ text }}</slot>
  </component>
</template>
